include navigation

.build-content
    div#apc-react-root
        .spinner
